import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Navigation } from './components/navigation/Navigation';
import { navItems } from './components/navigation/navData';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ScrollToTop from './components/shared/ScrollToTop';
import { ScrollProgress } from './components/shared/ScrollProgress';

const AboutPage = lazy(() => import('./pages/AboutPage'));
const ServicesPage = lazy(() => import('./pages/ServicesPage'));
const ResultsPage = lazy(() => import('./pages/ResultsPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const PrivacyPage = lazy(() => import('./pages/PrivacyPage'));
const TermsPage = lazy(() => import('./pages/TermsPage'));
const FaqPage = lazy(() => import('./pages/FaqPage'));

const App = () => {
  return (
    <>
      <ScrollToTop />
      <ScrollProgress />
      <div className="min-h-screen bg-background flex flex-col">
        <Navigation items={navItems} />
        <main className="flex-grow">
          <Suspense fallback={<div className="min-h-screen bg-black" />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/o-meni" element={<AboutPage />} />
              <Route path="/usluge" element={<ServicesPage />} />
              <Route path="/rezultati" element={<ResultsPage />} />
              <Route path="/pitanja" element={<FaqPage />} />
              <Route path="/kontakt" element={<ContactPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default App;
